import { render, staticRenderFns } from "./edu_liyou_user_page.vue?vue&type=template&id=36926afd&scoped=true"
import script from "./edu_liyou_user_page.vue?vue&type=script&lang=js"
export * from "./edu_liyou_user_page.vue?vue&type=script&lang=js"
import style0 from "./edu_liyou_user_page.vue?vue&type=style&index=0&id=36926afd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36926afd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36926afd')) {
      api.createRecord('36926afd', component.options)
    } else {
      api.reload('36926afd', component.options)
    }
    module.hot.accept("./edu_liyou_user_page.vue?vue&type=template&id=36926afd&scoped=true", function () {
      api.rerender('36926afd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/edu_liyou/edu_liyou_user_page.vue"
export default component.exports